
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TCPAPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">TCPA Policy</h1>
          <p className="text-gray-600 mb-8">Telephone Consumer Protection Act Compliance Policy</p>
          <p className="text-gray-600 mb-8">Last updated: January 1, 2025</p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Our Commitment to TCPA Compliance</h2>
              <p className="text-gray-700">
                Home Security Advisors is committed to complying with the Telephone Consumer Protection Act (TCPA) and all applicable federal and state telemarketing laws. We respect your privacy and your right to control how and when we contact you.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Consent to Contact</h2>
              <p className="text-gray-700 mb-4">
                By providing your phone number to Home Security Advisors through any of our forms, websites, or verbal communication, you expressly consent to receive:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Phone calls regarding security consultations and services</li>
                <li>Text messages with appointment confirmations and security alerts</li>
                <li>Automated or pre-recorded messages about your security system</li>
                <li>Marketing communications about our security services and promotions</li>
              </ul>
              <p className="text-gray-700 mt-4">
                This consent applies to the specific phone number you provide and remains valid until you withdraw it using the methods described below.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Types of Communications</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Service-Related Communications</h3>
                  <p className="text-gray-700">
                    We may contact you regarding installation appointments, system maintenance, security alerts, billing inquiries, and other service-related matters.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Marketing Communications</h3>
                  <p className="text-gray-700">
                    We may contact you with information about new security products, service upgrades, special offers, and other promotional materials.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Emergency Communications</h3>
                  <p className="text-gray-700">
                    We may contact you immediately in case of security system alerts, emergency situations, or urgent service matters.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Automated Communications</h2>
              <p className="text-gray-700 mb-4">
                We may use automated dialing systems and pre-recorded messages for:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Appointment reminders and confirmations</li>
                <li>Security system status updates</li>
                <li>Payment reminders and billing notifications</li>
                <li>Service maintenance alerts</li>
                <li>Marketing and promotional messages</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Text Message Communications</h2>
              <p className="text-gray-700 mb-4">
                By providing your mobile phone number, you consent to receive text messages including:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Security system alerts and notifications</li>
                <li>Appointment confirmations and reminders</li>
                <li>Service updates and maintenance notices</li>
                <li>Marketing messages and special offers</li>
              </ul>
              <p className="text-gray-700 mt-4">
                Message and data rates may apply. Message frequency varies based on your service level and preferences.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. How to Opt-Out</h2>
              <p className="text-gray-700 mb-4">
                You can withdraw your consent and stop receiving communications at any time using these methods:
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Phone Calls</h3>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>Ask to be placed on our Do Not Call list during any phone conversation</li>
                    <li>Call us at (702) 760-1474 and request to opt-out</li>
                    <li>Send written notice to our mailing address</li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Text Messages</h3>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>Reply "STOP" to any text message</li>
                    <li>Call us at (702) 760-1474</li>
                    <li>Email us at optout@homesecurityadvisors.com</li>
                  </ul>
                </div>
              </div>
              <p className="text-gray-700 mt-4">
                Please note that opting out of marketing communications will not stop service-related communications necessary for your security system operation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Third-Party Communications</h2>
              <p className="text-gray-700">
                We do not sell or share your phone number with third-party marketers. However, we may share your contact information with our authorized service partners who assist in providing security services, and they may contact you regarding your security system.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Hours</h2>
              <p className="text-gray-700 mb-4">
                We will generally contact you during reasonable hours:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Monday-Friday: 8:00 AM - 8:00 PM local time</li>
                <li>Saturday: 9:00 AM - 6:00 PM local time</li>
                <li>Sunday: Emergency communications only</li>
                <li>Emergency security alerts: 24/7 as needed</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Record Keeping</h2>
              <p className="text-gray-700">
                We maintain records of your consent and any opt-out requests in accordance with TCPA requirements. These records include the date, time, and method of consent or opt-out.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Questions and Complaints</h2>
              <p className="text-gray-700 mb-4">
                If you have questions about this TCPA Policy or wish to file a complaint about our calling practices, please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 font-semibold mb-2">Home Security Advisors</p>
                <p className="text-gray-700">Phone: (702) 760-1474</p>
                <p className="text-gray-700">Email: tcpa@homesecurityadvisors.com</p>
                <p className="text-gray-700 mt-3">
                  <strong>To Opt-Out:</strong> optout@homesecurityadvisors.com
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Policy Updates</h2>
              <p className="text-gray-700">
                We may update this TCPA Policy from time to time to reflect changes in our practices or applicable laws. We will post any updates on our website and update the "Last updated" date above.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
